import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import Vue from 'vue';
import axios from 'axios';
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
import { getHostUrl } from "../utils/enviroment";
var axiosInstance = axios;
axiosInstance = axios.create({
  baseURL: getHostUrl()
});
axiosInstance.interceptors.request.use(function (config) {
  var api = LocalStorage.getItem("api");
  if (api) {
    config.headers['Authorization'] = api;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
Vue.prototype.$axios = axiosInstance;